import React from 'react'
import { useState } from "react";

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from "react-router-dom"
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { useSelector } from 'react-redux';
import { currencyFormat } from '../../../helpers/numericFields';
import { Card, Col, Row } from 'react-bootstrap';
import styles from './WeedingPassTable.module.css'

export const WeedingPassTable = ({ edit2, viewImage2 }) => {
  const { role } = useSelector((state) => state.auth);
  const { weedingPass } = useSelector((state) => state.groupFiles);  

  const columns = [
    {
      name: "#",
      width: "80px",
      cell: (row, index) => <span className="text-muted fs-15 fw-semibold text-center w-100">{index + 1}</span>
    },
    {
      name: "Nombre",
      selector: row => [row.name],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.name}</span>
    },
    {
      name: "Fecha de solicitud",
      selector: row => [row.requestDate],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.birthdate}</span>
    },
    {
      name: "Categoría",
      selector: row => [row.category],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.category}</span>
    },
    {
      name: "Costo",
      selector: row => [row.amount],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{currencyFormat(row.amount)}</span>
    },
    {
      name: "Estado",
      selector: row => [row.statusWeedingPass],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.statusWeedingPass}</span>
    },
    {
      name: "Comprobante",
      cell: row => <span className="text-muted fs-15 fw-semibold text-center w-100">
        {
            row.image &&
            <i className={`fa fa-image ${styles.edit}`} onClick={() => viewImage2(row)}></i>
          }
      </span>
    },
    {
      name: "¿Se queda en el hotel?",
      selector: row => [row.staysInHotel],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center w-100">{row.staysInHotel ? "Sí" : "No"}</span>
    },
    {
      name: "Agente",
      selector: row => [row.agent],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.agent}</span>
    },
    {
      name: "Fecha de registro",
      selector: row => [row.insertDate],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.insertDate}</span>
    },
    {
      name: "Editar",
      sortable: false,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center w-100">
        {
          role === "DIRECTOR" && <i className={`fe fe-edit ${styles.edit}`} onClick={() => edit2(row)}></i>
        }
      </span>
    },
  ]
  const tableDatas = {
    columns,
    data: weedingPass,
  };
  return (
    <Row style={{ marginTop: 20, marginBottom: 50 }}>
      <Col sm={12} className="col-12">
        <Card>
          <Card.Header>
            <h3 className="card-title mb-0">Weeding Pass</h3>
          </Card.Header>
          <Card.Body>
            <div className="dataTable">
              <div className="table-responsive">
                <DataTableExtensions {...tableDatas} >
                  <DataTable
                    columns={columns}
                    data={weedingPass}
                    noHeader
                    defaultSortField="id"
                    defaultSortAsc={false}
                    striped={true}
                    center={true}
                    persistTableHead
                    pagination
                    highlightOnHover />
                </DataTableExtensions>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}